<template>
  <main-layout wide>
    <ClientsListContainer />
    <ImportClientsContainer />
  </main-layout>
</template>

<script>
import ClientsListContainer from '@/components/Widgets/ClientsListContainer';
import ImportClientsContainer from '@/components/Widgets/ImportClientsContainer';

export default {
  name: 'AssociateClients',
  components: {
    ClientsListContainer,
    ImportClientsContainer,
  },
};
</script>

<style lang="scss" scoped>
</style>
